import SubMenuNavigation from "@/components/ui/sub-menu-navigation"
import { useOrgNavigate } from "@/hooks/use-app-navigate";
import { useParams } from "react-router-dom";

export enum PAYMENT_FLOW_SUB_NAVIGATION_IDS {
    DETAILS = 'details',
    ABUSE_DETECTION = 'abuse-detection',
    SMART_RETRY = 'smart-retry',
    REBILL_3DS = 'rebill-3ds',
}

export const PaymentFlowSubNavigation = ({ activeId }: { activeId: PAYMENT_FLOW_SUB_NAVIGATION_IDS }) => {
    const { flowId } = useParams();
    const { orgRoutes, navigate } = useOrgNavigate();
    if (!flowId) {
        throw new Error('Flow ID is not defined')
    }
    return (
        <SubMenuNavigation
            items={[
                { id: PAYMENT_FLOW_SUB_NAVIGATION_IDS.DETAILS, labelKey: 'paymentFlows:tabs.details', path: orgRoutes.PAYMENT_FLOW_DETAILS(flowId) },
                { id: PAYMENT_FLOW_SUB_NAVIGATION_IDS.ABUSE_DETECTION, labelKey: 'paymentFlows:tabs.abuseDetection', path: orgRoutes.PAYMENT_FLOW_ABUSE_DETECTION(flowId) },
                { id: PAYMENT_FLOW_SUB_NAVIGATION_IDS.SMART_RETRY, labelKey: 'paymentFlows:tabs.smartRetry', path: orgRoutes.PAYMENT_FLOW_SMART_RETRY(flowId) },
                { id: PAYMENT_FLOW_SUB_NAVIGATION_IDS.REBILL_3DS, labelKey: 'paymentFlows:tabs.rebill3ds', path: orgRoutes.PAYMENT_FLOW_REBILL_3DS(flowId) },
            ]}
            activeId={activeId}
            onItemClick={(item) => navigate(item.path)}
        />
    )
}